module.exports = __webpack_public_path__ + "78ae0ee71ccf2589e8b195d1d84231f2.pdf";